app.factory("UserConfigService", ['$http',
    function ($http) {

        var UserConfigService = {};

        UserConfigService.set = function (params) {
            return $http.post("/config/set", {
                key: params.key,
                value: params.value
            }).then(function (resp) {
                return resp.data;
            });
        };

        return UserConfigService;
    }
]);